import React, { useState, useEffect, useRef, useCallback } from "react";
import DevDataService from "../services/DevService";
import { Link, useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const DevList = (props) => {
  const [dev, setDev] = useState([]);
  const devRef = useRef();
  devRef.current = dev;

  let { owner } = useParams();

  const retrieveDev = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    DevDataService.getAll(target)
      .then((response) => {
        // normalize common backend shapes into an array
        const payload = response?.data ?? response;
        const rows = payload?.data ?? payload?.dev ?? payload;
        setDev(Array.isArray(rows) ? rows : (rows ? [rows] : []));
      })
      .catch((e) => {
        console.error("DevList.retrieveDev error:", e?.response?.status, e?.response?.data || e?.message || e);
        setDev([]);
      });
  }, [owner]);

  const navigate = useNavigate();
  useEffect(() => {
    retrieveDev();
  }, [retrieveDev]);

  const deleteDev = useCallback((rowIndex) => {
    const id = devRef.current[rowIndex].id || devRef.current[rowIndex]._id;
    DevDataService.remove(id)
      .then(() => {
        if (props?.history?.push) props.history.push("dashboard/dev");
        const newDev = [...devRef.current];
        newDev.splice(rowIndex, 1);
        setDev(newDev);
      })
      .catch((e) => {
        console.error("deleteDev error:", e?.response?.status || e?.message || e);
      });
  }, [props.history]);

  // wrappers for TransactionTable (accept row objects)
  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/dev/${id}`);
  }, [props.history]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id && props?.history?.push) props.history.push(`/dashboard/dev/edit/${id}`);
  }, [props.history]);

  const handleDeleteRow = useCallback((row) => {
    const idx = devRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteDev(idx);
  }, [deleteDev]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={dev}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>

      <div className="col-md-8">
        <Link to={`/dashboard/dev/add/${owner || ""}`}>
           <button className="btn btn-sm btn-danger">Add Development Transaction</button>
        </Link>
      </div>
    </div>
  );
};

export default DevList;
